export const REMEMBER_CLONE_SPREADS_SESSION_KEY = "rememberCloneSpreads";
